import React, { FC } from 'react'

import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'

import { IItemProps } from '../types'

import { ListItem, LogoDesktop as Logo } from '../styles'

const InstitutionPartnersListItem: FC<IItemProps> = ({
  isDivider = true,
  name,
  description,
  logo,
}) => (
  <ListItem
    isDivider={isDivider}
    style={{
      width: '100%',
    }}
  >
    <Grid justifyContent='space-between'>
      <GridCol uxs={20}>
        <Text fontWeight='bold' lineHeight='h3' fontSize='h3' color='black'>
          {name}
        </Text>

        <Spacing spacing='xxsmall' />

        <Text color='black'>{description}</Text>
      </GridCol>

      {logo?.fallbackUrl && (
        <GridCol width='96px'>
          <Logo
            alt='логотип компании работодателя'
            fallbackUrl={logo?.fallbackUrl}
            webpUrl={logo?.webp}
          />
        </GridCol>
      )}
    </Grid>
  </ListItem>
)

export default InstitutionPartnersListItem
